/* ==========================================================================
   BCPO Dropdown Fix - Highlander Holsters
   
   This script fixes the BCPO (VO Product Options) dropdown being clipped
   on mobile. It waits for the BCPO app to inject its elements, then walks
   up the DOM tree and forces overflow: visible on every ancestor that 
   has overflow: hidden.
   
   Add this code to: Online Store → Themes → Edit Code → Assets → custom.js
   (Replace any previous BCPO fix code in custom.js)
   ========================================================================== */

(function() {
  'use strict';

  function fixBCPODropdownOverflow() {
    // Find all BCPO dropdown elements
    var dropdowns = document.querySelectorAll('.bcpo-dd, [class*="bcpo"] select, [class*="bcpo"] .inner');
    
    if (dropdowns.length === 0) return false;

    dropdowns.forEach(function(dropdown) {
      var parent = dropdown.parentElement;
      
      // Walk up every ancestor to the body
      while (parent && parent !== document.body) {
        var computedStyle = window.getComputedStyle(parent);
        var overflow = computedStyle.overflow;
        var overflowX = computedStyle.overflowX;
        var overflowY = computedStyle.overflowY;
        
        // Fix any ancestor that clips overflow
        if (overflow === 'hidden' || overflowX === 'hidden' || overflowY === 'hidden') {
          parent.style.setProperty('overflow', 'visible', 'important');
          parent.classList.add('bcpo-overflow-fix');
        }

        parent = parent.parentElement;
      }
    });

    // Also fix the dropdown list itself
    var innerLists = document.querySelectorAll('.bcpo-dd ul.inner, .bcpo-dd .inner');
    innerLists.forEach(function(list) {
      list.style.setProperty('max-height', '300px', 'important');
      list.style.setProperty('overflow-y', 'auto', 'important');
      list.style.setProperty('-webkit-overflow-scrolling', 'touch');
      list.style.setProperty('z-index', '9999', 'important');
    });

    return true;
  }

  // Strategy 1: Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(fixBCPODropdownOverflow, 500);
      setTimeout(fixBCPODropdownOverflow, 1500);
      setTimeout(fixBCPODropdownOverflow, 3000);
    });
  } else {
    setTimeout(fixBCPODropdownOverflow, 500);
    setTimeout(fixBCPODropdownOverflow, 1500);
    setTimeout(fixBCPODropdownOverflow, 3000);
  }

  // Strategy 2: MutationObserver to catch dynamically injected BCPO elements
  var observer = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      for (var j = 0; j < mutation.addedNodes.length; j++) {
        var node = mutation.addedNodes[j];
        if (node.nodeType === 1) {
          // Check if the added node is a BCPO element or contains one
          if (node.classList && (
            node.classList.contains('bcpo-dd') ||
            node.classList.contains('bcpo-dropdown') ||
            node.id === 'bcpo' ||
            (node.querySelector && node.querySelector('.bcpo-dd, #bcpo, [class*="bcpo"]'))
          )) {
            setTimeout(fixBCPODropdownOverflow, 100);
            setTimeout(fixBCPODropdownOverflow, 500);
          }
        }
      }
    }
  });

  // Observe the product area where BCPO injects its elements, rather than the
  // whole document. Falls back to documentElement if the product area isn't found.
  var bcpoScope = document.querySelector('.product-single, .product, main') || document.documentElement;
  observer.observe(bcpoScope, {
    childList: true,
    subtree: true
  });

  // Strategy 3: Also fix when dropdown is opened (click/touch)
  document.addEventListener('click', function(e) {
    var bcpoElement = e.target.closest('.bcpo-dd, [class*="bcpo"]');
    if (bcpoElement) {
      setTimeout(fixBCPODropdownOverflow, 50);
      setTimeout(fixBCPODropdownOverflow, 200);
    }
  }, true);

  document.addEventListener('touchstart', function(e) {
    var bcpoElement = e.target.closest('.bcpo-dd, [class*="bcpo"]');
    if (bcpoElement) {
      setTimeout(fixBCPODropdownOverflow, 50);
      setTimeout(fixBCPODropdownOverflow, 200);
    }
  }, { passive: true });

  // Disconnect observer after 30 seconds to avoid performance impact
  setTimeout(function() {
    observer.disconnect();
  }, 30000);

})();